module.exports = __webpack_public_path__ + "static/img/yinpintanchuang.08bc79f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yinpintanchuang.png
// module id = DjLZ
// module chunks = 1